export const Anexos: Array<{label: string, value: number }> = [
    { label: 'Outros',                      value: 0 },
    { label: 'Documento da Unidade',        value: 1 },
    { label: 'Historico de Ocorrência',     value: 2 },
    { label: 'Termo de Compromisso Estágio',value: 3 },
    { label: 'Contrato de Trabalho',        value: 4 },
    { label: 'Exame Médico',                value: 5 },
    { label: 'Comprovante Endereço',        value: 6 },
    { label: 'Cópia do RG',                 value: 7 },
    { label: 'Cópia do CPF',                value: 8 },
    { label: 'Certidão Nascimento ou Casamento', value: 9 },
    { label: 'Contrato Prestação Serviço',  value: 10 },
    { label: 'Recibo de Pagamento',         value: 11 },
    { label: 'Comprovante de Transação Bancária',  value: 12 },
    { label: 'Nota Fiscal',                 value: 13 },
    { label: 'Boleto Bancário',             value: 14 },
    { label: 'Guia Imposto',                value: 15 },
    { label: 'Pedido',                      value: 16 },
    { label: 'Orçamento',                   value: 17 },
    { label: 'Comprovante Retorno Itaú',    value: 18 },
    { label: 'Foto 3X4',                    value: 19 },
    { label: 'Histórico Escolar do Ensino Fundamental', value: 20 },
    { label: 'Comprovante de alfabetização',value: 21 },
    { label: 'Reservista',                  value: 22 },
    { label: 'Título Eleitor',              value: 23 },
    { label: 'CNH',                         value: 24 },
    { label: 'Redação',                     value: 25 },
    { label: 'Declaração Pendência Documental',value: 26 },
    { label: 'Cópia RG do responsável',        value: 27 },
    { label: 'Cópia CPF do responsável',       value: 28 },
    { label: 'Cópia RG com CPF',            value: 29 },
    { label: 'Cópia RG, CPF com Título',    value: 30 },
    { label: 'Cópia RG com CPF do responsável',value: 31 },
    { label: 'Comprovante Bolsa Convênio', value: 32 },
    { label: 'Contrato de Procuração EJA', value: 33 },
    { label: 'Atestado eliminação de disciplina original', value: 34 },
    { label: 'Assinatura no requerimento ou questionário teste', value: 35 },
    { label: 'Histórico Escolar do Ensino Médio', value: 36 },
    { label: 'Publicação Lauda GDAE', value: 37 }
];
